// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1O2mV","containerItemsCenter":"Skeleton_containerItemsCenter__1LbUp"};